const months = [
  { n: 1, m: 'Janeiro' },
  { n: 2, m: 'Fervereiro' },
  { n: 3, m: 'Março' },
  { n: 4, m: 'Abril' },
  { n: 5, m: 'Maio' },
  { n: 6, m: 'Junho' },
  { n: 7, m: 'Julho' },
  { n: 8, m: 'Agosto' },
  { n: 9, m: 'Setembro' },
  { n: 10, m: 'Outubro' },
  { n: 11, m: 'Novembro' },
  { n: 12, m: 'Dezembro' }
]

export default (month) => {
  let current = months.filter(function (mes) {
    return mes.n === month[0].schedule_month
  })

  return current[0].m
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/summary-billing/resources/months.js